<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Notifier from "../stores/notifier";

    export let agentId = null;
    export let closeCallback;

    let agent = null;
    let title = "Edit agent";

    const initialize = () => {
        if (agentId == 0) {
            agent = {
                id: 0,
                name: '',
                contact_person: '',
                phone: '',
                mobile: '',
                email: '',
            }
            title = "New agent";
            setFocusTo('agentName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            agent = result;
            setFocusTo('agentName');
        };

        const onFailure = err => {
        };

        R.handle(R.agent.details, agentId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Agent updated!");
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
            }
        };


        agent.name = agent.name.trim();
        if (!agent.name) {
            Notifier.showError("Type the name of the agent!");
            setFocusTo("agentName");
            return;
        }

        let action = agentId == 0 ? 'create' : 'edit';
        R.handle(R.agent[action], agent, onSuccess, onFailure, LOADER.POPUP);
    }

    const editUser = (data) => {
        app.editUser({id: data.id, agent_id: agent.id}, closeEdit);
    }

    const closeEdit = data => {
        if (data) {
            let user = agent.users.find(x => x.id === data.id);
            if (user) {
                user.name = data.name;
                user.email = data.email;
            }
            agent.users = agent.users;
        }
        app.clearEditUser();
    }

    const close = (param) => {
        agent = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if agent}
    <Modal {title} on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="agentName" bind:value="{ agent.name }">
            </div>
            <div class="form-group">
                <label>Contact person</label>
                <input type="text" class="form-control" bind:value="{ agent.contact_person }">
            </div>
            <div class="form-group">
                <label>Phone</label>
                <input type="tel" class="form-control" bind:value="{ agent.phone }">
            </div>
<!--            <div class="form-group">-->
<!--                <label>Mobile</label>-->
<!--                <input type="tel" class="form-control" bind:value="{ agent.mobile }">-->
<!--            </div>-->
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="userEmail" bind:value="{ agent.email }">
            </div>
            {#if agent.id > 0}
                {#if agent.users.length > 0}
                    <div class="legend">Users</div>
                    {#each agent.users as item}
                        <button class="btn btn-block btn-default text-start my-1" on:click={() => editUser(item)}>
                            {item.name}
                            <span class="d-block smaller text-gray">{item.email}</span>
                        </button>
                    {/each}
                {:else}
                    Agent has no associated users.
                {/if}
            {/if}
            <hr>
            <div class="text-end">
                <button class="btn btn-link me-4" on:click="{ () => close() }">Close</button>
                <button class="btn btn-primary px-4" on:click="{ save }">Update</button>
            </div>
        </div>
    </Modal>
{/if}